// The website uses its own API unless a backend origin is explicitly supplied.
export function apiEndpoint(value) {
  const base = typeof value === 'string' ? value.trim().replace(/\/+$/, '') : '';
  if (!base || base === 'undefined' || base === 'null' || base === '/api') return '/api';
  const url = new URL(base);
  if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password || url.search || url.hash) {
    throw new Error('La dirección del servidor no es válida.');
  }
  return base.endsWith('/api') ? base : `${base}/api`;
}

export function apiRequestPath(value) {
  if (typeof value !== 'string') return value;
  if (value === '/api') return '/';
  return value.startsWith('/api/') ? value.slice(4) : value;
}
